import { render } from "./DataService.vue?vue&type=template&id=6005061b&scoped=true"
import script from "./DataService.vue?vue&type=script&lang=js"
export * from "./DataService.vue?vue&type=script&lang=js"

import "./DataService.vue?vue&type=style&index=0&id=6005061b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6005061b"]])

export default __exports__